import { CSSProperties, ReactNode } from 'react';
import {
  ListItemText as MUIListItemText,
  ListItemTextProps as MUIListItemTextProps,
} from '@mui/material';
import * as R from 'ramda';

import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';

type CustomProps = {
  primaryTextStyle?: CSSProperties;
  secondaryTextStyle?: CSSProperties;
};

type AtomMUIProps = {
  classes?: any;
  primary?: ReactNode;
  secondary?: ReactNode;
  children?: ReactNode;
  disableTypography?: boolean;
};

export type ListItemTextProps = CustomProps & AtomMUIProps;

export const ListItemText = (props: ListItemTextProps) => {
  const { secondaryTextStyle, ...data } = props;

  const primaryTypographyProps: any = {
    fontWeight: 500,
    fontSize: fonts.md,
    color: colors.neutral.dark,
    ...props.primaryTextStyle,
  };

  const secondaryTypographyProps: any = {
    color: colors.neutral.gray,
    fontSize: fonts.sm,
    ...secondaryTextStyle,
  };

  const MUIProps: MUIListItemTextProps = R.omit(
    ['primaryTextStyle', 'secondaryTextStyle'],
    data,
  );

  return (
    <MUIListItemText
      {...MUIProps}
      slotProps={{
        primary: primaryTypographyProps,
        secondary: secondaryTypographyProps,
      }}
    />
  );
};

export default ListItemText;
